module.exports = __webpack_public_path__ + "img/se.c37f1b98.svg";